export const buildPostPaymentUpsellSearch = (
  search = "",
  paymentIntentId = "",
) => {
  const params = new URLSearchParams(
    String(search || "").startsWith("?") ? String(search).slice(1) : search,
  );
  const intentId = String(paymentIntentId || "").trim();
  if (intentId) {
    params.set("payment_intent_id", intentId);
  }
  const nextSearch = params.toString();
  return nextSearch ? `?${nextSearch}` : "";
};

export const navigateToPostPaymentUpsell = (
  navigate,
  pathname,
  paymentIntentId,
  search = window.location.search,
) => {
  navigate({
    pathname,
    search: buildPostPaymentUpsellSearch(search, paymentIntentId),
  });
};
